// store/slices/userSlice.js

import { createSlice } from "@reduxjs/toolkit";
import {
  getAllUser,
  updateUser as apiUpdateUser,
  deleteUser as apiDeleteUser,
} from "../../api/user-api";

const userSlice = createSlice({
  name: "users",
  initialState: [],
  reducers: {
    setUsers(state, action) {
      return action.payload;
    },
    updateUser(state, action) {
      return state.map((user) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
    },
    removeUser(state, action) {
      return state.filter((user) => user.id !== action.payload.id);
    },
  },
});
export const { setUsers, updateUser, removeUser } = userSlice.actions;

export const fetchUsers = () => async (dispatch) => {
  try {
    const userData = await getAllUser();
    dispatch(setUsers(userData || []));
  } catch (error) {
    console.error("Error fetching users:", error.message);
  }
};

export const updateUserApproval = (id, approvalStatus) => async (dispatch) => {
  try {
    const updatedUser = await apiUpdateUser(id, { approvalStatus });
    dispatch(updateUser(updatedUser));
  } catch (error) {
    console.error("Error updating user approval:", error.message);
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    await apiDeleteUser(id);
    dispatch(removeUser({ id }));
  } catch (error) {
    console.error("Error deleting user:", error.message);
  }
};

export default userSlice.reducer;
